const STORAGE_PREFIX = 'ydim:checkout:';

export function saveCheckoutSession(paymentId, checkout) {
  if (!paymentId || !checkout) return;
  try {
    sessionStorage.setItem(`${STORAGE_PREFIX}${paymentId}`, JSON.stringify(checkout));
  } catch {
    // ignore quota / private mode errors
  }
}

export function loadCheckoutSession(paymentId) {
  if (!paymentId) return null;
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${paymentId}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function formatAmountHalalas(amountHalalas, currency = 'SAR') {
  const n = Number(amountHalalas);
  if (!Number.isFinite(n)) return '—';
  const code = String(currency || 'SAR').toUpperCase();
  if (code === 'JPY') {
    return `${n} ${code}`;
  }
  return `${(n / 100).toFixed(2)} ${code}`;
}
